import React, { useEffect } from 'react';
import DataTable from '@salesforce/design-system-react/module/components/data-table';
import DataTableColumn from '@salesforce/design-system-react/module/components/data-table/column';
import { useDispatch, useSelector } from 'react-redux';
import {
  getNetwork,
  networkSelector,
  actions as networkActions,
} from '../../../../store/network/slice';
import { Checkbox, DataTableCell } from '@salesforce/design-system-react';

const CustomSelectionCell = ({ ...props }) => {
  const { item, handleSelect } = props;
  return (
    <DataTableCell>
      <Checkbox
        assistiveText={{
          label: 'Select chain',
        }}
        id={item.name}
        checked={item.selected}
        disabled={item.disabled}
        onChange={() => handleSelect(item.id)}
      />
    </DataTableCell>
  );
};
CustomSelectionCell.displayName = DataTableCell.displayName;

const CustomNameCell = ({ children, ...props }) => {
  const { item } = props;
  return (
    <DataTableCell title={children}>
      <div style={{ cursor: 'pointer' }}>
        <img src={item?.logo_url} width="25" alt={children} /> {children}
      </div>
    </DataTableCell>
  );
};
CustomNameCell.displayName = DataTableCell.displayName;

const HeaderCheckbox = ({ items, handleSelectAll }) => {
  const unselectedExists = items.findIndex((item) => !item.selected) > -1;
  return (
    <Checkbox
      indeterminate={unselectedExists}
      checked={!unselectedExists}
      assistiveText={{
        label: 'Select chain',
      }}
      id="header_checkbox"
      onChange={handleSelectAll}
    />
  );
};

const ChainList = () => {
  const dispatch = useDispatch();
  const { networks, loading } = useSelector(networkSelector);

  useEffect(() => {
    dispatch(getNetwork());
  }, []);

  const handleSelect = (id) => {
    dispatch(networkActions.setChainSelection(id));
  };

  const handleSelectAll = () => {
    dispatch(networkActions.setChainSelectionAll());
  }

  return (
    <div className="table-container">
      <div style={{ height: `${networks.length === 0 ? '100%' : 'calc(100vh - 320px)'}` }}>
        <DataTable
          assistiveText={{
            actionsHeader: 'actions',
            columnSort: 'sort this column',
            columnSortedAscending: 'asc',
            columnSortedDescending: 'desc',
            selectAllRows: 'Select all rows',
            selectRow: 'Select this row',
          }}
          fixedHeader
          fixedLayout
          items={networks}
          id="DataTableExample-FixedHeaders"
          hasMore={loading}
          noRowHover
        >
          <DataTableColumn label={<HeaderCheckbox items={networks} handleSelectAll={handleSelectAll} />} width="1rem">
            <CustomSelectionCell handleSelect={handleSelect} />
          </DataTableColumn>
          <DataTableColumn label="Name" property="name" width="10rem">
            <CustomNameCell />
          </DataTableColumn>
        </DataTable>
        {networks.length < 1 && !loading && (
          <div>
            <div>
              <img
                src="/assets/empty-state/empty-folder.png"
                alt=""
                style={{ height: '150px', display: 'flex', margin: 'auto' }}
              />
              <p style={{ textAlign: 'center', fontWeight: '700', fontSize: '20px' }}>
                Data not available
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChainList;
